module.exports = __webpack_public_path__ + "static/media/portfolio-dark.a91c3baf.jpg";